import { useEffect } from "react";
import { useProfile, useUserState } from "@/hooks/useUserData";

export function ReminderScheduler() {
  const { data: state } = useUserState();
  const { data: profile } = useProfile();

  useEffect(() => {
    const reminder = state?.reminder;
    if (!reminder?.enabled) return;
    if (typeof Notification === "undefined" || Notification.permission !== "granted") return;

    const check = () => {
      const now = new Date();
      const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
      if (hhmm !== reminder.time) return;

      const dayKey = `bw_reminded_${now.toISOString().slice(0, 10)}`;
      if (localStorage.getItem(dayKey)) return;

      // Skip if today's gesto is already done
      if (profile?.has_test) {
        const gestoId = `${profile.priority}-0`;
        if (state?.actions?.[gestoId]) return;
      }

      localStorage.setItem(dayKey, "1");
      try {
        new Notification("Be Woman", {
          body: "È il momento del tuo gesto di oggi 💗 Un piccolo passo per te.",
          icon: "/bewoman-logo.png",
        });
      } catch {}
    };

    check();
    const interval = setInterval(check, 30000);
    return () => clearInterval(interval);
  }, [state, profile]);

  return null;
}
